import Base from "./Base";
import store from "../storeWire";
import { setAll } from "../store/slice/model/ProductPricing";
import System from "../helper/system";

class ProductPricing extends Base {
    setAll(data, justProcess = false) {

        if (justProcess) {
            data = this.matchAll(data);
            data = this.processAll(data);
            return data;
        }
        this.data = data;
        this.matchAll();
        this.processAll();
        store.dispatch(setAll({
            data: this.data
        }));
    }

    matchAll(data = false) {
        if (!data) {
            data = this.data;
        }
        this.data = data;
        return this.data;
    }

    setParamsForServerCallNew(params_single) {
        if (params_single.demandQuantity === undefined) {
            params_single.demandQuantity = "0";
        }

        if (params_single.currency === undefined) {
            params_single.currency = window.mct;
        }
        if (params_single.SalesOrg === undefined) {
            params_single.SalesOrg = System.auth('salesOrg');
        }

        if (params_single.customerPartNumber === undefined) {
            let CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER = store.getState().entities.Cart.CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER;
            if (params_single.ItemNumber !== undefined &&
                CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER[params_single.ItemNumber] !== undefined &&
                CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER[params_single.ItemNumber].CUSTOMER_PART_NUMBER !== undefined) {
                params_single.customerPartNumber = CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER[params_single.ItemNumber].CUSTOMER_PART_NUMBER;
            }
            else {
                params_single.customerPartNumber = "";
            }
        }
        return params_single;
    }

    processAll(data = false) {
        if (!data) {
            data = this.data;
        }
        this.data = data;
        return this.data;
    }
}

export default ProductPricing;